import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,{attrs:{"justify":"center"}},[_c(VCol,{attrs:{"cols":"auto"}},[_c('div',{staticClass:"error-page round-block pa-5 ma-16"},[_c(_vm.errorPage,{tag:"component",attrs:{"error":_vm.error}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }